export const DOCUMENT_LIST_REQUEST = 'DOCUMENT_LIST_REQUEST'
export const DOCUMENT_LIST_SUCCESS = 'DOCUMENT_LIST_SUCCESS'
export const DOCUMENT_LIST_FAIL = 'DOCUMENT_LIST_FAIL'

export const DOCUMENT_CREATE_REQUEST = 'DOCUMENT_CREATE__REQUEST'
export const DOCUMENT_CREATE_SUCCESS = 'DOCUMENT_CREATE__SUCCESS'
export const DOCUMENT_CREATE_FAIL = 'DOCUMENT_CREATE__FAIL'
export const DOCUMENT_CREATE_RESET = 'DOCUMENT_CREATE__RESET'

export const DOCUMENT_DELETE_REQUEST = 'DOCUMENT_DELETE_REQUEST'
export const DOCUMENT_DELETE_SUCCESS = 'DOCUMENT_DELETE_SUCCESS'
export const DOCUMENT_DELETE_FAIL = 'DOCUMENT_DELETE_FAIL'
export const DOCUMENT_DELETE_RESET = 'DOCUMENT_DELETE_RESET'
